import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { getEnvironment } from '../../../../../shared/utils/helpers';

const mutation = graphql`
  mutation ResendCompleteStaffAccountEmailMutation($input: ResendCompleteStaffAccountEmailInput!) {
    resendCompleteStaffAccountEmail(input: $input) {
      emailSent
    }
  }
`;

const ResendCompleteStaffAccountEmailMutation = (id, callback) => {
  const config = {
    mutation,
    variables: { input: { id } },
    onCompleted: response => {
      callback(response.resendCompleteStaffAccountEmail);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default ResendCompleteStaffAccountEmailMutation;
